<div class="sorting">
  <p class="caption text-gray py-2 px-3">Sorting</p>
  <div class="note">
    @for (opt of options; track opt) {
      <div
        class="dropdown-item py-2 px-3 clickable"
        [ngClass]="{
          active: isActive && sortDirection === opt.value
        }"
        (click)="onSort(opt.value)"
      >
        <i class="icon icon-12 mr-1" [ngClass]="opt.icon"></i>
        {{ opt.title }}
      </div>
    }
  </div>
</div>
